import React from "react";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getGallery } from "../Service/Api"; // same API call you were using

const Gallery = () => {
  const navigate = useNavigate();

  // Fetch gallery data using TanStack React Query
  const {
    data: galleryData = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["gallery"],
    queryFn: getGallery,
  });

  const galleryDummyHome = [
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg",
    },
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg",
    },
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg",
    },
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg",
    },
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg",
    },
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg",
    },
  ];

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: { slidesToShow: 3, slidesToScroll: 1 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  const handleModal = (id) => {
    navigate(`/sub-gallery/${id}`);
  };

  const galleryItems =
    isLoading || isError || galleryData.length === 0
      ? galleryDummyHome
      : galleryData;

  return (
    <>
      <div className="row">
        <Slider {...settings}>
          {galleryItems.map((item, index) => (
            <div className="item" key={index}>
              <div className="galleryimg">
                <div className="galleryimgbox">
                  <a
                    onClick={() =>
                      !isLoading &&
                      !isError &&
                      handleModal(item._id ? item._id : index)
                    }
                    className="view-more"
                  >
                    <LazyLoad>
                      <img
                        src={
                          item.attachments
                            ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                            : item.img
                        }
                        className="img-fluid"
                        alt={item.title || "Gallery"}
                      />
                    </LazyLoad>
                    <div className="gallerydesc">
                      <h6>{item.title || "Gallery Title"}</h6>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default Gallery;
